import {inject, Injectable} from '@angular/core';
import {RuntimeService} from "../../../core/services/runtime.service";
import {createLogger} from "../logger/logger";

const logger = createLogger('GuestCartService');

@Injectable({
    providedIn: 'root'
})
export class GuestCartService {
    private readonly guestTokenKey = 'guest_token';
    readonly #runtimeService = inject(RuntimeService);

    getGuestToken(): string {
        if (this.#runtimeService.isServer) return '';
        return localStorage.getItem('guest_token') || this.generateGuestToken();
    }

    clearGuestToken(): void {
        if (this.#runtimeService.isBrowser) {
            localStorage.removeItem(this.guestTokenKey);
        }
    }

    private generateGuestToken(): string {
        if (this.#runtimeService.isBrowser) {
            const token = 'guest_' + Math.random().toString(36).slice(2) + Date.now();
            localStorage.setItem('guest_token', token);
            return token;
        }
        // You can later enhance this to include a device ID or fingerprint.
        return '';
    }
}
